import { render, staticRenderFns } from "./TimeAxis.vue?vue&type=template&id=1ddea2ca&"
import script from "./TimeAxis.vue?vue&type=script&lang=js&"
export * from "./TimeAxis.vue?vue&type=script&lang=js&"
import style0 from "./TimeAxis.vue?vue&type=style&index=0&id=1ddea2ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports